
import React, { useEffect, useState } from "react";

import moment from "moment";
import { Button, Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FcFinePrint } from "react-icons/fc";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../components/Pagination/Pagination";
import { DEFAULT_ITEMS_PER_PAGE, OfficePageType } from '../../../core/constants/common';
import OfficePageService from "../../../core/service/OfficePageService";

const OfficePageList = ({ t, type }) => {
  const navigate = useNavigate();

  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageData, setPageData] = useState([]);

  useEffect(() => {
    listPage();
  }, [type]);

  const listPage = (pageNumber, itemsPerPageVal) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    let perPage;
    if (itemsPerPageVal > 0) {
      perPage = itemsPerPageVal;
    } else {
      perPage = itemsPerPage;
    }
    OfficePageService.getPages(
      pageNumber,
      perPage,
      type
    ).then((response) => {
      const totalPages = parseFloat(response.headers["x-total-count"]);
      setItemTotalCount(totalPages);
      setPageData([...response.data]);
    }).catch((error) => {
    });
  };

  const onEditTerms = () => {
    navigate('/admin/office_page_editor/' + type.toString());
  };

  return (
    <>
      <div className="FormsList">
        <div className="List_header">
          <h5 className="MH">
            { 
              type === OfficePageType.TERMS_OF_USE ? t("TermsOfUse.label")
              : type === OfficePageType.PRIVACY_NOTICE ? t("PrivacyNotice.label")
              : type === OfficePageType.GDPR_STATEMENT ? t("GDPRStatement.label")
              : ''
            }
          </h5>
          <div className="List_sorts_menu">
            <ul>
              <li>
                <Button variant="primary"  onClick={() => onEditTerms()}>
                  {t("Edit.label")}
                </Button>
              </li>
            </ul>
          </div>
        </div>

        <div className="List_Table_01">          
          <div className="card List_table-card01">
            <Table responsive="sm">
              <thead>
                <tr>                  
                  <th>{t("Name.label")}</th>
                  <th>{t("CreatedDate.label")}</th>
                  <th>{t("Status.label")}</th>
                </tr>
              </thead>
              <tbody>
                {pageData?.length > 0
                  ?
                  (
                    pageData?.map((page, index) => (
                      <tr key={page.id}>
                        <td>{page.name}</td>
                        <td>{page.createdDate ? moment(page.createdDate).format("MMM DD, YYYY") : ""}</td>
                        <td>{index === 0 ? t("Active.label") : t("Inactive.label")}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        <div className="Nodatafound_box">
                          <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                        </div>
                      </td>
                    </tr>
                  )}
              </tbody>
            </Table>
            <div className="p-2 List_footer_count">
              <Pagination
                itemsTotalCount={itemsTotalCount}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                alwaysShown={true}
                setItemsPerPage={setItemsPerPage}
                pageClicked={(pageNum, perPage) => {
                  listPage(pageNum, perPage);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withTranslation()(OfficePageList);
